import { fetchCSRFToken } from "../csrf";

export default function signOut() {
  let form = document.createElement("form");
  form.setAttribute("method", "POST");
  form.setAttribute("action", "/sign-out");
  form.style.display = "none";

  fetchCSRFToken().then(csrfToken => {
    let input = document.createElement("input");
    input.setAttribute("type", "hidden");
    input.setAttribute("name", "_csrf");
    input.setAttribute("value", csrfToken);
    form.appendChild(input);
    document.querySelector("body").appendChild(form);
    form.submit();
  });
}
